import React, {useState} from 'react';
import {Card, Col, Tab, Tabs} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import BsrCalcTool from "../tools/BsrCalcTool";
import AmazonSuggestions from "../tools/AmazonSuggestions";
import UserWishlist from "../useraccount/UserWishlist";
import FaqUserDashboard from "./FaqUserDashboard";
import UserProfile from "../useraccount/UserProfile";
import UserChangePass from "../useraccount/UserChangePass";
import UserSupport from "../useraccount/UserSupport";
import DeleteAccount from "./DeleteAccount";
import EmailNotifications from "../useraccount/EmailNotifications";

const ProfileInDashboard = () => {

    const [key, setKey] = useState('profile');

    return (
        <Card className="p-2 w-100 mt-2">
            <Row className="p-2">

                <Col>
                    <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3 nav-success" >
                        <Tab eventKey="profile" title="Customer Profile">
                            <UserProfile />
                        </Tab>
                        <Tab eventKey="pass_change" title="Password Change">
                            <UserChangePass />
                        </Tab>
                        <Tab eventKey="email-notifications" title="Email Notifications">
                            <EmailNotifications />
                        </Tab>
                        <Tab eventKey="support" title="Support">
                            <UserSupport />
                        </Tab>
                        <Tab eventKey="wishlist" title="Wishlist">
                            <UserWishlist />
                        </Tab>
                        <Tab eventKey="faq" title="FAQ">
                            <FaqUserDashboard />
                        </Tab>
                        <Tab eventKey="deleting" title="Deleting Account">
                            <DeleteAccount />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </Card>
    );
};

export default ProfileInDashboard;